import type {AddAiItemPopOverContentState} from '@Components/add-ai-item-button/add-ai-item-button.types';

export interface AddAiItemDropdownPopupContentProps {
  dropdownContentState: AddAiItemPopOverContentState;
  showAsNewFeature: AddAiItemPopUpSubPanel[];

  onSubPanelBack(): void;
  onDone(): void;
  onClickAiSubtitlesOption(): void;
  onClickAiImagesOption(): void;
  onClickAiVoiceOption(): void;
  onClickAiRemoveBgOption(): void;
  AiImagePanelId?: string;
  AiVoicePanelId?: string;
  AiSubtitlePanelId?: string;
}

export enum AddAiItemPopUpSubPanel {
  AI_IMAGE,
  AI_SUBTITLE,
  AI_VOICE,
}
